<template>
    <modal-template>
        <template #header>
            <div v-if="isNew">
                <div class="popup-header-title">
                    <span style="width:100%;font-size:larger;font-weight:bold;">add new dairy</span>
                </div>
                <div class="popup-header-title">
                    <span>new dairies require a bounce of the RCO api servers</span>
                </div>
            </div>
            <div v-else>
                <div class="popup-header-title">
                    <span>configuration for</span>
                </div>
                <div class="popup-header">
          <span>
            <span style="padding-right:1%;"><sup>[<b>{{ participant.dairy.id }}</b>]</sup></span>
            <span>{{ participant.contact.name }}</span>
          </span>
                </div>
            </div>
        </template>
        <template #body>
            <div class="table-container" style="padding:0;margin:0;border:none;">
                <table>
                    <tbody>
                    <tr v-if="isNew">
                        <td class="configuration">dairies</td>
                        <td style="text-align:left;">
                            <div v-if="!review">
                                <select v-model="dairy"
                                        :disabled="review"
                                        :class="{'invalid-indicator' : dairy.id <= 0}">
                                    <option :disabled="true">select a dairy...</option>
                                    <option v-for="b2bEntry in b2bEntries" v-bind:key="b2bEntry.id" :value="b2bEntry">
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>[<sup><b>{{ b2bEntry.id }}</b></sup>] {{ b2bEntry.name.trim() }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </option>
                                </select>
                            </div>
                            <div v-else class="review">
                                <span>[<b>{{ dairy.id }}</b>] {{ dairy.name }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="configuration">schema</td>
                        <td style="text-align:left;" :class="{'review' : review}">
                            <span>{{ dairy.schema }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="configuration">url</td>
                        <td style="text-align:left;" :class="{'review' : review}">
                            <span>{{ dairy.url }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="configuration">poc</td>
                        <td style="text-align:left;">
                            <div v-if="!review">
                                <input type="text"
                                       size="50"
                                       v-model="dairy.pointOfContact"
                                       :disabled="review"
                                       :class="{'invalid-indicator' : dairy.pointOfContact === ''}"/>
                            </div>
                            <div v-else class="review">
                                <span>{{ dairy.pointOfContact }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="configuration">time zone</td>
                        <td style="text-align:left;">
                            <div v-if="!review">
                                <select v-model="dairy.timeZone"
                                        :disabled="review"
                                        :class="{'invalid-indicator' : dairy.timeZone === ''}">
                                    <option :disabled="true">select a time zone...</option>
                                    <option v-for="timeZone in timeZones"
                                            :value="timeZone"
                                            :key="timeZone">{{ timeZone }}
                                    </option>
                                </select>
                            </div>
                            <div v-else class="review">
                                <span>{{ dairy.timeZone }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="configuration">account orders per delivery day</td>
                        <td style="text-align:left;">
                            <div v-if="!review">
                                <select v-model="dairy.accountOrdersPerDeliveryDay"
                                        :disabled="review">
                                    <option :disabled="true">select ...</option>
                                    <option :value="1">1</option>
                                    <option :value="2">2</option>
                                    <option :value="3">3</option>
                                    <option :value="4">4</option>
                                    <option :value="5">5</option>
                                </select>
                            </div>
                            <div v-else class="review">
                                <span>{{ dairy.accountOrdersPerDeliveryDay }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="justify-align">
                <div style="float:left;">
                    <button v-if="!review" type="button" @click="$emit('close', true)">close</button>
                    <button v-else type="button" @click="review = !review">back</button>
                </div>
                <div style="float:right;">
                    <button v-if="!review" type="button" @click="isValid">review</button>
                    <button v-else type="button" @click="save">submit</button>
                </div>
            </div>
        </template>
    </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'


export default {
    name: 'Configuration',
    props: ['participant', 'isNew'],
    emits: ['close', 'apierror', 'apierrortext'],
    data: function () {
        return {
            b2bEntries: [],
            dairy: {
                id: 0,
                url: '',
                schema: '',
                pointOfContact: '',
                accountOrdersPerDeliveryDay: 0,
                timeZone: ''
            },
            timeZones: {},
            review: false,
        }
    },
    components: {
        ModalTemplate,
    },
    methods: {
        isValid: function () {
            this.review = false

            this.axios
                .get('email/isValid',
                    {
                        params: {
                            emailAddress: this.dairy.pointOfContact
                        }
                    })
                .then(response => {
                    this.review =
                        (this.dairy.id > 0) &&
                        (this.dairy.url.trim() !== '') &&
                        (this.dairy.schema.trim() !== '') &&
                        response.data === true &&
                        (this.dairy.accountOrdersPerDeliveryDay > 0) &&
                        (this.dairy.timeZone.trim() !== '');

                })
                .catch(error => {
                    this.validEmailAddress = false
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })

        },
        save: function () {
            this.axios
                .post('control/dairy/save', {
                    dairy: this.dairy
                })
                .then(() => {
                    this.$emit('close', true)
                })
                .catch(error => {
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })
        },
        setApiError: function (isError) {
            this.$emit('apierror', isError)
        },
        setApiErrorText: function (text) {
            this.$emit('apierrortext', text)
        },
    },
    created() {
        if (this.isNew) {
            this.axios
                .get("control/dairy/list/b2bEntries")
                .then(response => {
                    this.b2bEntries = _.orderBy(response.data, ['id'], ['asc'])
                })
                .catch(error => {
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })
        } else {
            this.dairy = this.participant.dairy
        }

        this.timeZones = {}
        this.axios
            .get("control/list/timeZones")
            .then(response => {
                this.timeZones = response.data
            })
            .catch(error => {
                this.setApiError(true)
                this.setApiErrorText(error.response.statusText)
            })
    },
}
</script>
